/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function ArrowDown(props) {
    return (
        <SvgIcon {...props}>
            <polygon fill="currentColor" points="-0.033,3.269 4.18,7.408 -0.053,11.557 1.84,13.424 5.725,9.608 7.947,7.425 5.724,5.243 1.839,1.424" transform="rotate(90, 4, 7)" />
        </SvgIcon>
    );
}

ArrowDown.defaultProps = {
    viewBox: '0 0 8 16'
};

export default ArrowDown;
